import { PazienteList } from './../types/index';
import axios from 'axios';
import { Paziente, IdVersion, PazienteCreateCommand, PazienteUpdateCommand } from '../types';
import { utilityService } from './common/utility-service';

const baseUrl = '/api/v1/pazienti';

export const getByKey = async (id: number): Promise<Paziente> => {
    return (await axios.get(`${baseUrl}/${id}`)).data;
};

export const getList = async (): Promise<PazienteList[]> => {
    return (await axios.get(`${baseUrl}`)).data;
};

export const create = async (command: PazienteCreateCommand): Promise<IdVersion> => {
    return (await axios.post(`${baseUrl}/create`, command)).data;
};

export const update = async (command: PazienteUpdateCommand): Promise<IdVersion> => {
    return (await axios.post(`${baseUrl}/update`, command)).data;
};

export const remove = async (items: IdVersion[]): Promise<void> => {
    return (await axios.delete(`${baseUrl}/remove?${utilityService.toQueryStringMultiple(items)}`)).data;
};

